import { authRoles } from "../../../auth/authRoles";
import EditMitra from "./EditMitra";
import Mitra from "./Mitra";
import TambahMitra from "./TambahMitra";

const mitraRoute = [
  {
    path: "/mitra/edit/:id",
    exact: true,
    component: EditMitra,
    auth: authRoles.all,
  },
  {
    path: "/mitra/tambah",
    exact: true,
    component: TambahMitra,
    auth: authRoles.all,
  },
  {
    path: "/mitra",
    exact: true,
    component: Mitra,
    auth: authRoles.all,
  },
];

export default mitraRoute;
